// The same availability filter is used by lightweight metadata and full fields.
export function usableForecastSteps(payload) {
    const steps = payload?.available_steps || [];
    if (!steps.length) return [];
    const count = entry => {
        const declared = Number(entry?.items_count);
        return Number.isFinite(declared) && declared > 0 ? declared : (payload?.items_by_step?.[entry?.key] || []).length;
    };
    const counts = steps.map(count).filter(n => n > 0);
    const maximum = counts.length ? Math.max(...counts) : 0;
    if (maximum < 50) return steps;
    const minimum = Math.max(100, Math.floor(maximum * .70));
    const filtered = steps.filter(entry => count(entry) >= minimum);
    return filtered.length ? filtered : steps;
}
export function forecastTemporalCoverage(payload, timeOf) {
    const timestamps = usableForecastSteps(payload).map(timeOf).filter(Number.isFinite).sort((a,b) => a-b);
    if (!timestamps.length) return {available:false,timestamps:[]};
    if (timestamps.length === 1) return {startMs:timestamps[0],endMs:timestamps[0],timestamps,toleranceMs:0};
    const firstHalf=(timestamps[1]-timestamps[0])/2,lastHalf=(timestamps.at(-1)-timestamps.at(-2))/2;
    return {startMs:timestamps[0]-firstHalf,endMs:timestamps.at(-1)+lastHalf,timestamps,toleranceMs:Math.max(firstHalf,lastHalf)};
}
